module.exports = __webpack_public_path__ + "static/media/union_free-flow-wine.5ad66a6d.jpg";